module.exports = __webpack_public_path__ + "static/media/bolinhaMagica.2b7f0998.png";